import React, { useState } from "react";

const CardCvc = ({
  dataCy,
  placeholder,
  error,
  name,
  width,
  value,
  margin,
  icon,
  min,
  max,
  comment,
  setValue,
  submitCount,
  register,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className="input-container"
      style={{
        width: width == "full" ? "100%" : `calc(${width == "half" ? 50 : width}% - 6px)`,
        marginRight: margin ? "12px" : "0px",
        backgroundColor: "transparent",
      }}
    >
      <div className={`input input--text ${error && "input--error"}`}>
        <input
          data-cy={dataCy}
          maxLength={max}
          minLength={min}
          type="tel"
          autoComplete="cc-csc"
          className="styledInput"
          name={name}
          value={value}
          {...register(name)}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/[^0-9]/g, "");
            setValue(name, numericValue, {
              shouldValidate: true,
              shouldTouch: true,
            });
          }}
        />
        <label className={value?.length > 0 ? "styledLabel styledLabel--active cvv" : "styledLabel cvv"}>
          {placeholder}
        </label>

        {icon && (
          <div
            className="input__helper"
            onClick={() => {
              if (window.isMobile) {
                setIsVisible(!isVisible);
              }
            }}
          >
            <div
              className="input__img--alt"
              style={{
                backgroundImage: `url(${icon}`,
              }}
            />

            {comment && (
              <span className="input__comment" visible={isVisible.toString()}>
                {comment}
              </span>
            )}
          </div>
        )}
      </div>
      {error && <span className="formError">{error}</span>}
    </div>
  );
};

export default CardCvc;
